module.exports = require('./flattenJsonApiResponse')
